import { z } from "zod"

const checkedRowStatusValues = ["no_change", "not_found", "ready"] as const
const checkedRowStatusSchema = z.enum(checkedRowStatusValues)
type CheckedRowStatus = z.infer<typeof checkedRowStatusSchema>

const matchedByValues = ["phone", "email"] as const
const matchedBySchema = z.enum(matchedByValues).nullable()
type MatchedBy = z.infer<typeof matchedBySchema>

const noCallCsvCheckRequestRowSchema = z.object({
  email: z.string().optional(),
  noCall: z.boolean(),
  phone: z.string().optional(),
  rowIndex: z.number(),
})

type NoCallCsvCheckRequestRow = z.infer<typeof noCallCsvCheckRequestRowSchema>

const noCallCsvCheckRequestSchema = z.object({
  rows: z.array(noCallCsvCheckRequestRowSchema),
})

type NoCallCsvCheckRequest = z.infer<typeof noCallCsvCheckRequestSchema>

const noCallCsvCheckedRowSchema = z.object({
  matchedBy: matchedBySchema,
  rowIndex: z.number(),
  status: checkedRowStatusSchema,
  studentId: z.string().optional(),
})

type NoCallCsvCheckedRow = z.infer<typeof noCallCsvCheckedRowSchema>

const noCallCsvCheckResponseSchema = z.object({
  rows: z.array(noCallCsvCheckedRowSchema),
})

type NoCallCsvCheckResponse = z.infer<typeof noCallCsvCheckResponseSchema>

const noCallCsvWriteRequestSchema = z.object({
  email: z.string().optional(),
  noCall: z.boolean(),
  phone: z.string().optional(),
})

type NoCallCsvWriteRequest = z.infer<typeof noCallCsvWriteRequestSchema>

const noCallCsvWriteResponseSchema = z.discriminatedUnion("status", [
  z.object({
    status: z.literal("ok"),
    studentId: z.string(),
    warnings: z.array(z.string()),
  }),
  z.object({
    message: z.string(),
    status: z.literal("error"),
    studentId: z.string().optional(),
  }),
])

type NoCallCsvWriteResponse = z.infer<typeof noCallCsvWriteResponseSchema>

export {
  type CheckedRowStatus,
  checkedRowStatusSchema,
  checkedRowStatusValues,
  type MatchedBy,
  matchedBySchema,
  matchedByValues,
  type NoCallCsvCheckedRow,
  noCallCsvCheckedRowSchema,
  type NoCallCsvCheckRequest,
  noCallCsvCheckRequestRowSchema,
  type NoCallCsvCheckRequestRow,
  noCallCsvCheckRequestSchema,
  type NoCallCsvCheckResponse,
  noCallCsvCheckResponseSchema,
  type NoCallCsvWriteRequest,
  noCallCsvWriteRequestSchema,
  type NoCallCsvWriteResponse,
  noCallCsvWriteResponseSchema,
}
